import { render } from "./ProvidersAnalysisPage.vue?vue&type=template&id=34bf0e56&ts=true"
import script from "./ProvidersAnalysisPage.vue?vue&type=script&lang=ts"
export * from "./ProvidersAnalysisPage.vue?vue&type=script&lang=ts"

import "./ProvidersAnalysisPage.vue?vue&type=style&index=0&id=34bf0e56&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__